var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultFacility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149px",
    height: "149px",
    viewBox: "0 0 149 149",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "940B6C42-1F17-41CC-89DF-FDBBCEF9F0F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Directory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Find-Members",
    transform: "translate(-455.000000, -1330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(455.000000, 1330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    fill: "#7F91A5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 0,
    y: 0,
    width: 149,
    height: 149
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(20.000000, 19.000000)",
    fill: "#DEE2E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7072587,80.1870075 L26.7072587,83.2930278 C26.7072587,84.9589385 28.0495211,86.3037099 29.7154318,86.3037099 C31.371307,86.3037099 32.723605,84.9589385 32.723605,83.2930278 L32.723605,80.0490179 C38.0750923,80.5081469 42.091844,82.4600724 42.091844,84.8008777 C42.091844,87.4778759 36.8106059,89.6530936 30.3025148,89.6530936 C23.7843882,89.6530936 18.5031501,87.4778759 18.5031501,84.8008777 C18.5031501,82.6356956 21.9528899,80.8041973 26.7072587,80.1870075 M54.6865305,105.960955 C57.8703268,105.960955 113.733532,103.758139 113.733532,94.4350603 C113.733532,85.124526 83.8525129,89.720834 83.8826197,81.7625978 C83.8525129,78.8146383 95.9855615,79.8031455 92.7415516,74.1004119 C89.8788948,69.3560788 50.7651172,69.9255995 50.7651172,69.9255995 C50.7651172,69.9255995 42.5434463,69.9732686 32.723605,71.1800504 L32.723605,37.4277957 C43.9835558,31.8705784 73.7566924,14.6319148 58.9792614,15.6706001 C46.4146816,16.5512246 37.495536,12.1807178 32.723605,8.9567791 L32.723605,3.00817315 C32.723605,1.34226241 31.371307,0 29.7154318,0 C28.0495211,0 26.7072587,1.34226241 26.7072587,3.00817315 L26.7072587,72.0606749 C13.5831938,74.2860707 0,78.8146383 0,88.0649589 C0,105.960955 51.5002254,105.960955 54.6865305,105.960955",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFacility);
export default __webpack_public_path__ + "static/media/defaultFacility.c43ba00d6c4d9529b5097a9b1e586b2c.svg";
export { ForwardRef as ReactComponent };